import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const addUser = (userData) => async (dispatch) => {
    try {
        const { data } = await api.addUser(userData);

        dispatch({
            type: Actions.ADD_USER,
            payload: data
        })
    } catch (error) {
        // console.log(error);
    }
}